import { render, staticRenderFns } from "./HistoryStack.vue?vue&type=template&id=6f0eb31a&"
import script from "./HistoryStack.vue?vue&type=script&lang=js&"
export * from "./HistoryStack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports